<!-- static content data from lang: user_management -->
<template>
    <div>
        <div v-loading="loading">
            <base-header class="pb-6">
                <div class="row align-items-center pb-4">
                    <div class="col-lg-12 col-12">
                        <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.addHeaderTitle}}</h6>
                        <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                            <route-bread-crumb></route-bread-crumb>
                        </nav>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div>
                    <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <div class="col-md-12">
                        <Alert :type=alertType dismissible  v-if="alertMessage">  <span class="alert-inner--text">{{alertMessage}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                            <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input
                                                    :label="lang.label.company"
                                                    name="company"
                                                    :rules="{required: selected.includes('Administrator') ? false : true}"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    >
                                                    <el-select
                                                        v-model="model.company"
                                                        :placeholder="lang.label.selectCompany"
                                                        filterable
                                                        autocomplete="off"
                                                        @change="siteList"
                                                        :disabled="type != 1"
                                                    >
                                                        <el-option
                                                            v-for="(option,index) in companyName"
                                                            :key="index"
                                                            :label="option.Name"
                                                            :value="option.ID"
                                                            ></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col-lg-6">
                                                <base-input
                                                    :label="lang.label.site"
                                                    name="site"
                                                    :rules="{required: selected.includes('Administrator') ? false : true}"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    >
                                                    <el-select
                                                        v-model="model.site"
                                                        autocomplete="off"
                                                        :placeholder="lang.label.selectsite"
                                                        filterable
                                                        multiple
                                                        :disabled="type == 4"
                                                        >
                                                        <el-option
                                                            v-for="(option,index) in siteName"
                                                            :key="index"
                                                            :label="option.Name"
                                                            :value="option.ID"
                                                            ></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input
                                                    :label="lang.label.userName"
                                                    name="user name"
                                                    rules="required"
                                                    autocomplete="off"
                                                    v-model="model.userName"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    ></base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <!--<base-input
                                                    :label="lang.label.password"
                                                    name="password"
                                                    rules="required"
                                                    v-model="model.password"
                                                    type="password"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    ></base-input>-->
                                              <base-input
                                                          name="Password"
                                                          :label="lang.label.password"
                                                          autocomplete="off"
                                                          labelClasses="form-control-label asterisk-mark"
                                                          rules="required"
                                                          group
                                              >
                                                <input :type="passwordFieldType" v-model="model.password" autocomplete="new-password" class="form-control" aria-label="password">
                                                <div class="icon-pos" @click="switchVisibility" v-if="model.password!=''">
                                                  <i class="fa fa-eye" v-if="passwordFieldType=='password'"></i>
                                                  <i class="fa fa-eye-slash" v-else aria-hidden="true"></i>
                                                </div>
                                              </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input
                                                    :label="lang.label.name"
                                                    name="name"
                                                    rules="required"
                                                    v-model="model.name"
                                                    autocomplete="off"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    ></base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input
                                                    :label="lang.label.emailAddress"
                                                    name="email address"
                                                    autocomplete="off"
                                                    rules="required|email"
                                                    v-model="model.emailAddress"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    ></base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <b-form-checkbox
                                                      v-model="model.receiveQuestionnaireFailsEmail"
                                                      name="receiveQuestionnaireFailsEmail"
                                                      class="d-inline-block align-middle"
                                                    >
                                                    <span class="form-control-label">{{lang.label.receiveQuestionnaireFailsEmail}}</span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <b-form-checkbox
                                                      v-model="model.receiveHighTempAlertEmail"
                                                      name="receiveHighTempAlertEmail"
                                                      class="d-inline-block align-middle"
                                                    >
                                                    <span class="form-control-label">{{lang.label.receiveHighTempAlertEmail}}</span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label class="form-control-label asterisk-mark">{{lang.label.roles}}</label>
                                                    <!-- <b-form-checkbox
                                                      v-model="allSelected"
                                                      :indeterminate="indeterminate"
                                                      aria-describedby="roles"
                                                      aria-controls="roles"
                                                      @change="toggleAll"
                                                      class="d-inline-block ml-3 align-middle"
                                                    ></b-form-checkbox>-->
                                                    <base-input name="role" rules="required">
                                                                <div>
                                                            <b-form-group>
                                                                <b-form-checkbox-group
                                                                    id="roles"
                                                                    v-model="selected"
                                                                    :options="roles"
                                                                    name="roles"
                                                                    aria-label="Individual roles"
                                                                    ></b-form-checkbox-group>
                                                            </b-form-group>
                                                        </div>
                                                    </base-input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-right mb-3">
                                    <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                                    <base-button
                                        type="danger"
                                        @click="$router.push({path: 'list'})"
                                        >{{lang.label.buttons.cancel}}</base-button>
                                </div>
                            </form>
                        </validation-observer>
                    </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import { Select, Option } from "element-ui";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import Alert from "@/components/BaseAlert.vue";
    import Login from "../Login";

    export default {
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            RouteBreadCrumb,
            Alert
        },
        data() {
            return {
                lang: this.$lang.user_management,
                alertType: '',
                passwordFieldType: "password",
                loading: true,
                model: {
                    company: "",
                    site: [],
                    userName: "",
                    password: "",
                    name: "",
                    emailAddress: "",
                    receiveQuestionnaireFailsEmail: false,
                    receiveHighTempAlertEmail: false
                },
                companyName: [],
                siteName: [],
                selects: {
                    simple: "Select"
                },
                roles: [],
                selected: [],
                alertMessage: ""
            };
        },
        watch: {
            selected(val,oldVal) {
                if (val.includes("Site Admin") && !oldVal.includes("Company Admin")) {
                    //let temp = [0, 1];
                    let temp = ["Administrator", "Company Admin"];
                    if (!val.includes("Approve Access")) {
                        this.selected.push("Approve Access")
                    }
                    if (!val.includes("Visitor Questionnaires Access")) {
                        this.selected.push("Visitor Questionnaires Access")
                    }
                    if (!val.includes("Report Access")) {
                        this.selected.push("Report Access")
                    }
                    this.disableOthers(temp, true);
                } else {
                    let temp = ["Company Admin", "Site Admin"];
                    if (val.includes("Administrator")) {
                        if (!val.includes("Report Access")) {
                            this.selected.push("Report Access")
                        }
                        //let temp = [1, 2];
                        this.disableOthers(temp, true);
                    } else if (!val.includes("Company Admin")) {
                        if (val.includes("Report Access")) {
                            this.selected.splice(this.selected.indexOf("Report Access"), 1)
                        }
                        //let temp = [1, 2];
                        this.disableOthers(temp, false);
                    }
                    if (val.includes("Company Admin")) {
                        if (!val.includes("Site Admin")) {
                            this.selected.push("Site Admin")
                        }
                        if (!val.includes("Approve Access")) {
                            this.selected.push("Approve Access")
                        }
                        if (!val.includes("Visitor Questionnaires Access")) {
                            this.selected.push("Visitor Questionnaires Access")
                        }
                        if (!val.includes("Report Access")) {
                            this.selected.push("Report Access")
                        }
                        let temp = ["Administrator", "Site Admin"];
                        //let temp = [0, 2];
                        this.disableOthers(temp, true);
                    } else if (!val.includes("Administrator")) {
                        if (val.includes("Site Admin")) {
                            this.selected.splice(this.selected.indexOf("Site Admin"), 1)
                        }
                        if (val.includes("Approve Access")) {
                            this.selected.splice(this.selected.indexOf("Approve Access"), 1)
                        }
                        if (val.includes("Visitor Questionnaires Access")) {
                            this.selected.splice(this.selected.indexOf("Visitor Questionnaires Access"), 1)
                        }
                        //let temp = [0, 3, 4];
                        let temp = ["Administrator", "Registrar", "Approver/Reporter"];
                        this.disableOthers(temp, false);
                    }
                    if(val.includes("Registrar")) {
                        //let temp = [3];
                        let temp = ["Registrar"];
                        this.disableOthers(temp, true);
                    }
                    if(val.includes("Approver/Reporter")) {
                        //let temp = [4];
                        let temp = ["Approver/Reporter"];
                        this.disableOthers(temp, true);
                    }
                }

            }
        },
        computed: {
            ...mapGetters({
                type: "type",
                login: "login",
            }),
        },
        created(){
            if(this.type == 1){
                this.roles.push({ text: 'Administrator', value: 'Administrator', disabled: this.type != 1 ? true : false })
            }
            if(this.type != 4){
                this.roles.push({text: 'Company Admin', value: 'Company Admin', disabled: false})
            }
            this.roles.push({text: 'Site Admin', value: 'Site Admin', disabled: false})
            this.roles.push({text: 'Registrar', value: 'Registrar', disabled: false})
            this.roles.push({text: 'Approver/Reporter', value: 'Approver/Reporter', disabled: false})
            this.roles.push({text: 'Approve Access', value: 'Approve Access', disabled: true})
            this.roles.push({text: 'Visitor Questionnaires Access', value: 'Visitor Questionnaires Access', disabled: true})
            this.roles.push({text: 'Report Access', value: 'Report Access', disabled: true});
        },
        mounted() {
            this.companyList();
        },
        methods: {
            switchVisibility(){
                this.passwordFieldType =
                    this.passwordFieldType === "password" ? "text" : "password";
            },
            disableOthers(data, flag) {
                let newRoles = this.roles;
                newRoles.forEach((object, index) => {
                    if(flag){
                        if(this.selected.includes(object.value)){
                            this.roles[index].disabled = false;
                        }else{
                            this.roles[index].disabled = true;
                        }
                    }else{
                        if (data.includes(object.value)) {
                            this.roles[index].disabled = flag;
                            if(this.type == 4){
                                this.roles[0].disabled = false;
                            }
                        }
                        if (index > (newRoles.length - 4)){
                            console.log(this.roles[index].value+ " ==== disabled");
                            this.roles[index].disabled = true;
                        }
                    }
                });
            },
            onSubmit() {
                this.loading = true;
                let data = {
                    Username: this.model.userName,
                    Password: this.model.password,
                    Name: this.model.name,
                    EmailAddress: this.model.emailAddress ? this.model.emailAddress : '',
                    IsRegistrar: this.selected.includes('Registrar'),
                    IsAdministrator: this.selected.includes('Administrator'),
                    IsCompanyAdmin: this.selected.includes('Company Admin'),
                    IsSiteAdmin: this.selected.includes('Site Admin'),
                    ApproveAccess: this.selected.includes('Approve Access'),
                    ReportsAccess: this.selected.includes('Report Access'),
                    VisitorQuestionnaireAccess: this.selected.includes('Visitor Questionnaires Access'),
                    VisitorAdminAccess: this.selected.includes('Visitor Admin Access'),
                    IsApproverReporter: this.selected.includes('Approver/Reporter'),
                    CompanyID: this.type != 1 ? this.login.CompanyID : this.model.company,
                    CompanySitesID: this.model.site.join(","),
                    ReceiveQuestionnaireFailsEmail: this.model.receiveQuestionnaireFailsEmail,
                    ReceiveHighTempAlertEmail: this.model.receiveHighTempAlertEmail
                };
                if(this.type != 1 ? this.login.CompanyID : this.model.company){
                    data.CompanyID = this.type != 1 ? this.login.CompanyID : this.model.company;
                }
                if(this.model.site.length){
                    data.CompanySitesID = this.model.site.join(",");
                }
                console.log(data);
                //return false;
                this.$store
                        .dispatch("createSystemUser", data)
                        .then(response => {
                            if (response.status  == 200) {
                                this.model.userName = "";
                                this.model.password = "";
                                this.model.name = "";
                                this.model.emailAddress = "";
                                this.loading = false;
                                 this.flash({message: response.data.message, variant: 'success'});
                                this.$router.push({name: "userManagement"});
                            } else {
                                if(typeof response.data.message != 'object'){
                                    this.alertMessage = response.data.message;
                                }else{
                                    var array = new Array();
                                    for (let key of Object.keys(response.data.message)) {
                                        let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                        array.push(obj)
                                    }this.alertMessage = array.join(', ');
                                }
                                this.alertType = "danger";
                                this.loading = false;
                            }
                        }).catch(error => {
                    this.loading = false;
                });
            },
            companyList() {
                this.loading = true;
                this.$store.dispatch("companyList").then(response => {
                    this.companyName = response.data;
                    if(this.type != 1){
                        this.model.company = this.login.CompanyID;
                        this.siteList(this.login.CompanyID);
                    }else{
                        this.loading = false;
                    }
                });
            },
            siteList(val) {
                this.loading = true;
                this.model.site = [];
                this.siteName = [];
                this.$store.dispatch('getSiteUponCompany', val).then(response => {
                console.log(response);
                    this.siteName = response;
                    if(this.type == 4){
                        this.model.site = response;
                    }
                    this.loading = false;
                });
            }
        },
    };
</script>
<style>
    .no-border-card .card-footer {
        border-top: 0;
    }
    .modal-header {
        padding-bottom: 0;
    }
</style>
